import React from 'react';

import './icons.scss';

const Icon = (props) => {
    let iconClassName = "";

    switch (props.icon.id) {
    case "nts-logo":
        iconClassName = "icon-nts";
        break;
    case "icons-play":
        iconClassName = "icon-play";
        break;
    case "icons-stop":
        iconClassName = "icon-stop";
        break;
    case "icons-chat":
        iconClassName = "icon-chat";
        break;
    case "icons-arrow":
        iconClassName = "icon-arrow";
        break;
    case "icons-close":
        iconClassName = "icon-close";
        break;
    default:
        console.error("Unknown icon id", props.icon.id);
        break;
    }

    return (
        <svg className={`${iconClassName} ${props.className}`} width={props.width} height={props.height} fill={props.fill}>
            <use xlinkHref={`#${props.icon.id}`} />
        </svg>
    );
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/icon/index.js